const publicPaths = new Set(['/login', '/register', '/forgetPass', '/productManual', '/show', '/pricing']);
const restrictedApplyStatuses = new Set([1, 4]);
const restrictedAccountPaths = new Set(['/account', '/productManual', '/show', '/login', '/index', '/pricing']);

export const isPublicPath = (path: string) => publicPaths.has(path);

export const isRestrictedApplyStatus = (applyStatus: unknown) =>
  typeof applyStatus === 'number' && restrictedApplyStatuses.has(applyStatus);

export const canAccessWithRestrictedApplyStatus = (path: string) => restrictedAccountPaths.has(path);

export const getPostLoginPath = (applyStatus: unknown) => {
  if (applyStatus === 3) {
    return '/aomView';
  }
  return '/account';
};
